module.exports = __webpack_public_path__ + "media/add-ons/meetup@1x-a9a500f3.png";